// @ts-strict-ignore
import {Component, computed, inject, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ExamFlow, ExamFlowScheduleMode, ParticipantType, Permissions} from "@models";
import {ThemeService} from "@services";
import {Router} from "@angular/router";
import {UntilDestroy} from "@ngneat/until-destroy";
import {Translations} from "@translations";

export interface DialogData_ExamFlowDetailDialogInput extends MatDialogDataBaseInput {
	examFlow: ExamFlow;
}

@UntilDestroy()
@Component({
	selector: "sim-exam-flow-detail-dialog",
	templateUrl: "./exam-flow-detail-dialog.component.html",
	styleUrl: "./exam-flow-detail-dialog.component.scss",
	standalone: false,
})
export class ExamFlowDetailDialogComponent
	extends BasicMaterialDialog<ExamFlowDetailDialogComponent, DialogData_ExamFlowDetailDialogInput>
	implements OnInit
{
	// Constants
	protected readonly Permissions = Permissions;
	protected readonly ExamFlowScheduleMode = ExamFlowScheduleMode;
	public readonly T = Translations;

	// Properties
	public examFlow: ExamFlow;
	public isDarkTheme: boolean;

	// Readonly
	protected readonly ParticipantType = ParticipantType;

	// Injections
	private _themeService = inject(ThemeService);
	private _router = inject(Router);
	readonly #router = inject(Router);

	// Derived
	readonly showEditButton = computed<boolean>(() => !this.#router.url.includes("web-manager/list/exam-flow"));

	public constructor(_injector: Injector) {
		super(_injector);
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.examFlow = this.data.examFlow;
		this.isDarkTheme = this._themeService.isDarkTheme();
	}

	protected async navigateToEdit(): Promise<void> {
		await this._router.navigate(["/web-manager/list/exam-flow", this.examFlow.id]);
	}
}
